import {
  InstantAnswerBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getOrderFulfillmentCTA } from "./shared";

export const AddOrUpdate: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: () => addOrUpdateBuilder(strictLocalize).getTitle(),
  descriptionBuilder: () => addOrUpdateBuilder(strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getOrderFulfillmentCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getOrderFulfillmentCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const addOrUpdateBuilder = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      strictLocalize({
        defaultMessage: "Add tracking info when shipping on your own",
        description: {
          text: "Title for the answer of add or update issue of Ship on Your Own issue tree",
        },
      }),
    getDescription: () => [
      strictLocalize({
        defaultMessage:
          "You can add or update tracking information in “Step 4. Shipping info” of the order fulfillment page. Check out the Help Center articles we’ve found for you below for more detailed instructions.",
      }),
    ],
  };
};
